import * as React from "react";
import InputField from "../../components/Forms/InputField";

export default function UserFilters({ filters, setFilters, filterUsers, clearFilters }) {

  const handleChange = (index, newValue) => {
    setFilters(prevFields =>
      prevFields.map((field, i) =>
        i === index ? { ...field, value: newValue } : field
      )
    );
  };
  
  return (
    <section className="flex flex-col my-5 font-semibold rounded-none">
      <div className="flex flex-col px-5 py-3.5 w-full bg-white rounded-md shadow-[0px_0px_25px_rgba(94,92,154,0.1)] max-md:max-w-full">
        <header className="flex flex-wrap gap-5 justify-between w-full text-gray-900 max-md:max-w-full">
          <div className="flex gap-1.5 items-start my-auto text-base whitespace-nowrap">
            <img
              loading="lazy"
              src="https://cdn.builder.io/api/v1/image/assets/TEMP/4dd39feef0ff4934d9e2e86b8c7285d5d7532aeb26adcdc1e878d021439e2681?placeholderIfAbsent=true&apiKey=d62bea31e5c5472d8bb4326e92b00478"
              alt=""
              className="object-contain shrink-0 w-4 aspect-square"
            />
            <span className="self-stretch">Filters</span>
            <img
              loading="lazy"
              src="https://cdn.builder.io/api/v1/image/assets/TEMP/d18f51a0b2d597a302f55b77fc1071043eab5f274a1cc9e9b3fe3e2c97520a8c?placeholderIfAbsent=true&apiKey=d62bea31e5c5472d8bb4326e92b00478"
              alt=""
              className="object-contain shrink-0 aspect-square w-[18px]"
            />
          </div>
          {/* <button className="flex overflow-hidden gap-2.5 justify-center items-center py-2.5 pr-4 pl-4 text-sm text-center rounded-md bg-navBtn">
            <img
              loading="lazy"
              src="https://cdn.builder.io/api/v1/image/assets/TEMP/64502c1ba20e77db17ab3834e8f3476cfc1696fefa2225489d56ce1c0781f1a9?placeholderIfAbsent=true&apiKey=d62bea31e5c5472d8bb4326e92b00478"
              alt=""
              className="object-contain shrink-0 self-stretch my-auto w-5 aspect-square"
            />
            <span className="self-stretch my-auto w-[94px]">Add New User</span>
          </button> */}
        </header>

        {/* Dynamically render filters in rows of up to 4 (more compact) */}
        {(() => {
          const cols = 4; // number of filters per row
          const rows = Math.ceil(filters.length / cols);
          return Array.from({ length: rows }, (_, rowIndex) => (
            <div key={rowIndex} className="flex gap-3 items-center text-sm mt-2 flex-wrap">
              {filters.slice(rowIndex * cols, rowIndex * cols + cols).map((filter, filterIndex) => {
                const actualIndex = rowIndex * cols + filterIndex;
                return (
                  <div key={actualIndex} className="flex-1 min-w-[220px]">
                    <InputField
                      data={filter.data}
                      label={filter.label}
                      name={filter.name}
                      placeholder={filter.placeholder}
                      type={filter.type}
                      value={filter.value}
                      onChange={e => handleChange(actualIndex, e.target.value)}
                    />
                  </div>
                );
              })}
            </div>
          ));
        })()}

        <div className="flex flex-wrap gap-7 w-full max-md:max-w-full mt-2">
          {/* <div className="flex flex-col grow shrink-0 text-sm basis-0 min-h-[65px] w-fit max-md:max-w-full">
            <label className="gap-1 self-stretch w-full text-gray-900 max-md:max-w-full">
              Challenge Status
            </label>
            <div className="flex flex-wrap gap-2.5 items-center px-4 py-2.5 mt-2.5 w-full whitespace-nowrap bg-white rounded-md border border-solid border-navBtn text-slate-400 max-md:max-w-full">
              <div className="flex-1 shrink self-stretch my-auto basis-0 max-md:max-w-full">
                Active
              </div>
              <img
                loading="lazy"
                src="https://cdn.builder.io/api/v1/image/assets/TEMP/a97445af61c606db8fefad9d6b93a7820aef5720564dc82f0b896304ce347e97?placeholderIfAbsent=true&apiKey=d62bea31e5c5472d8bb4326e92b00478"
                alt=""
                className="object-contain shrink-0 self-stretch my-auto aspect-square w-[18px]"
              />
            </div>
          </div> */}
          <div className="flex shrink gap-3 items-center self-end justify-end w-full mt-6 text-base text-center whitespace-nowrap basis-auto grow-0">
            <button className="overflow-hidden gap-2.5 self-stretch px-5 py-2.5 my-auto rounded-md bg-navBtn text-zinc-600 w-[150px] h-full border border-navBtn" type="reset" onClick={clearFilters}>
              Reset
            </button>
            <button className="overflow-hidden gap-2.5 self-stretch px-5 py-2.5 my-auto text-white bg-primary rounded-md w-[150px] border border-primary" onClick={() => filterUsers()}>
              Search
            </button>
          </div>
        </div>
      </div>
    </section>
  );
}